import { CaseData } from './types';

/**
 * Returns a version of the case with content in the requested language.
 * Falls back to Chinese if the English translation is not yet available.
 */
export function localizeCase(caseData: CaseData, lang: string): CaseData {
  if (lang !== 'en') return caseData;
  return {
    ...caseData,
    testimony: caseData.testimony_en ?? caseData.testimony,
    issues: caseData.issues_en ?? caseData.issues,
    questions: caseData.questions_en ?? caseData.questions,
    documents: caseData.documents_en ?? caseData.documents,
  };
}
